import { useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const Section = ({ title, children }) => (
  <div className="mb-6">
    <h3 className="font-display uppercase tracking-[0.1em] text-sm mb-2" style={{ color: "#C5A059" }}>{title}</h3>
    <p className="font-body text-[13px] leading-relaxed" style={{ color: "#E5E5EA" }}>{children}</p>
  </div>
);

export const Footer = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <footer data-testid="app-footer" className="relative z-10 text-center py-6 px-6">
        <p className="mb-2">
          <Link
            data-testid="blog-link"
            to="/observatoire"
            className="font-body text-xs tracking-[0.1em] uppercase transition-colors hover:text-[#E6C687]"
            style={{ color: "#C5A059" }}
          >
            Découvrez le blog L'Observatoire des Possibles →
          </Link>
        </p>
        <p className="mb-2">
          <Link
            data-testid="arcanes-link"
            to="/arcanes"
            className="font-body text-xs tracking-[0.1em] uppercase transition-colors hover:text-[#E6C687]"
            style={{ color: "#C5A059" }}
          >
            Les 22 arcanes du Tarot de Marseille →
          </Link>
        </p>
        <p className="font-body text-[11px] tracking-wide leading-relaxed" style={{ color: "#A2A2A6" }}>
          © 2026 La Petite Boîte Intuitive — Propulsé par L'Observatoire des Possibles{" "}
          <span className="opacity-60">|</span>{" "}
          <button
            data-testid="legal-link"
            onClick={() => setOpen(true)}
            className="underline underline-offset-2 hover:text-[#E6C687] transition-colors"
            style={{ color: "#A2A2A6" }}
          >
            Mentions Légales &amp; CGV
          </button>
        </p>
      </footer>

      {open && (
        <div
          data-testid="legal-modal"
          className="fixed inset-0 z-50 flex items-center justify-center px-4 py-8"
          style={{ backgroundColor: "rgba(10,10,12,0.75)", backdropFilter: "blur(6px)" }}
          onClick={() => setOpen(false)}
        >
          <div
            className="relative w-full max-w-lg max-h-[85vh] overflow-y-auto rounded-2xl border p-8 sm:p-10"
            style={{ borderColor: "rgba(230,198,135,0.25)", backgroundColor: "#1C1C1E" }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              data-testid="legal-close"
              onClick={() => setOpen(false)}
              className="absolute top-4 right-4 transition-colors"
              style={{ color: "#A2A2A6" }}
              aria-label="Fermer"
            >
              <X size={20} strokeWidth={1.5} />
            </button>

            <h2 className="font-display uppercase tracking-[0.08em] text-xl sm:text-2xl font-light mb-8 text-center" style={{ color: "#F4EAD4" }}>
              Mentions Légales &amp; CGV
            </h2>

            <Section title="Identité">
              « La Petite Boîte Intuitive » est une création propulsée par L'Observatoire des Possibles.
              Responsable de la publication : Balin. F.
            </Section>

            <Section title="Nature du service">
              La Petite Boîte Intuitive propose un service de tirage de cartes intuitif, à but de
              divertissement. Les interprétations sont fournies à titre indicatif et ne constituent en
              aucun cas un avis médical, juridique, psychologique ou financier. Aucun résultat ne peut
              être garanti. Service réservé aux personnes majeures.
            </Section>

            <Section title="Prix">
              Chaque consultation est fixée à 5 € TTC, réglée en un paiement unique et sécurisé, sans
              abonnement ni engagement.
            </Section>

            <Section title="Confidentialité des données">
              Les informations que tu saisis (prénoms et question) sont utilisées uniquement pour générer
              ton tirage. Elles restent strictement confidentielles, ne sont jamais revendues, cédées ni
              partagées à des tiers, et leur protection est garantie.
            </Section>

            <p className="font-body text-[11px] leading-relaxed mt-6" style={{ color: "#A2A2A6" }}>
              En validant une consultation, tu reconnais avoir pris connaissance et accepté les présentes
              mentions légales et conditions générales de vente.
            </p>
          </div>
        </div>
      )}
    </>
  );
};
